import { Component, ElementRef, ViewChild } from '@angular/core';
import { SelectItemGroup } from 'primeng/api';

@Component({
  selector: 'app-show-all-appointments-modal',
  templateUrl: './show-all-appointments-modal.component.html',
  styleUrls: ['./show-all-appointments-modal.component.scss']
})
export class ShowAllAppointmentsModalComponent {
  colors = ['#4C5C86','#864C80','#864C4C','#4C5C86','#864C80','#864C4C'];
  professionalFilters = [
    {
      label: 'Ana clara',
      command: () => {
       
      }
    },
    {
      label: 'Carlos Augusto',
      command: () => {
       
      }
    }
  ];
  filterUnits = [
    {
      label: 'Vila Nova',
      command: () => {
       
      }
    },
  ];

  cities!: any[];

  selectedCities!: any[];

  constructor() {
      this.cities = [
          {name: 'New York', code: 'NY'},
          {name: 'Rome', code: 'RM'},
          {name: 'London', code: 'LDN'},
          {name: 'Istanbul', code: 'IST'},
          {name: 'Paris', code: 'PRS'}
      ];
  }
  
}
